/* 
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version                    Author                        Description
----------   -----------        --------------- ----------------     ------------------------
01 07 2018    1                   Professional service Initial version     
01-11-2019   1.1             Gokulakannan                             profile Page with full functionalites like Image upload
05-12-2019    1.2                    Pappuraj                              Date picker added 
*/
import { Component, OnInit } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { Platform, NavController, MenuController, ActionSheetController } from '@ionic/angular';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import * as moment from 'moment';
import { LangactionService } from 'src/app/service/lang/langaction.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  headingtitle: any;
  imgUrl: any;
  langcontext: any;
  editflg: any;
  role: any;
  formsubmitted: any = false;
  profileName: any;
  profileMobile: any;
  profileEmail: any;
  profileDoB: any;
  profileForm: any;

  constructor(public langAction: LangactionService ,public platform: Platform, public _sanitizer: DomSanitizer, public navctrl: NavController, public actionsheet: ActionSheetController, public menuCtrl: MenuController, public formBuilder: FormBuilder, public camera: Camera, public api: RestapiService, public cmndef: CommonDefinitionService, public cmndecl: CommonDeclarationService, public statusBar: StatusBar) {
    this.imgUrl = "assets/images/profile_icon.png";

    this.profileForm = formBuilder.group({
      profileEmail: ['', Validators.compose([
      Validators.required,
      Validators.pattern('[A-Za-z0-9-!#$%&*+./?^_`{}|]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')])]
    });

    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['profile'];
    } else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].profile;
    }
    this.headingtitle = this.langcontext.heading.text;
    this.editflg = "edit";
    this.role = localStorage.role;


  }

  ionViewWillEnter() {
    this.getprofileData("new");
    this.menuCtrl.swipeEnable(false);

  }

  ngOnInit() {

  }

  async getprofileData(flg: any) {
    let req: any;
    let res: any;
    await this.cmndef.loaderstart();
    req = {
      "mobileNo": localStorage.user,
      "requestType": "getProfileData",
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId,
    }

    await this.api.postapi("updateDetails", req).then(async data => {
      res = data;
      this.cmndecl.storeProcess(res, "profile");
      if (res.displayName == "" || res.displayName == undefined)
        this.profileName = "User"
      else
        this.profileName = res.displayName
      this.profileEmail = res.emailID;
      this.profileMobile = res.mobileNo;
      if (res.dob == undefined || res.dob == "")
        this.profileDoB = ""
      else {
        let split = res.dob.split("/");
        if (!this.cmndecl.cordovaSupport) {
          this.profileDoB = split[1] + "/" + split[0] + "/" + split[2];
        } else {
          this.profileDoB = split[0] + "/" + split[1] + "/" + split[2];
        }
      }
      if (res.profilePicture == "" || res.profilePicture == undefined) {
        this.imgUrl = "assets/images/profile_icon.png";
      } else {
        this.imgUrl = "data:image/jpeg;base64," + res.profilePicture;
      }
      this.cmndecl.profileImg = this.imgUrl;
      await this.cmndef.loaderend();
      if (flg == "update") {
        this.cmndef.Showtoast(this.langcontext.updatemsg.msg);
        sessionStorage.CurrentPage = "/va/chat"
        this.navctrl.navigateRoot("va/chat");
      }
      this.langAction.languagechange("update");
    }, async err => {
      await this.cmndef.loaderend();
    })
  }

  showDatepicker() {
    if (this.profileDoB == undefined || this.profileDoB == null || this.profileDoB == "") {
      let fulldate = new Date('01/01/2001');
      let mdte = new Date();
      this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
        this.profileDoB = data;
      }, err => {
        console.log(err);
      });
    }
    else {
      let split = this.profileDoB.split("/");
      let sdate = split[1] + "/" + split[0] + "/" + split[2]
      var d = new Date(sdate);
      let mdte = new Date();
      this.cmndef.showdatePicker(d, "", mdte).then(data => {
        this.profileDoB = data;
      }, err => {
        console.log(err);
      });
    }
  }

  async takePhoto() {
    if (this.editflg != "edit") {
      this.cmndecl.Actionsheetenable = true;
      const actionSheet = await this.actionsheet.create({
        header: "Select Image source",
        buttons: [{
          text: 'Use Gallery',
          handler: () => {
            this.cmndecl.Actionsheetenable = false;
            this.Photo(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.cmndecl.Actionsheetenable = false;
            this.Photo(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.cmndecl.Actionsheetenable = false;
          }
        }
        ]
      });
      await actionSheet.present();
    }
  }

  Photo(sourceType) {
    const options: CameraOptions = {
      quality: localStorage.imagequality,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      correctOrientation: true,
      sourceType: sourceType,
    }

    this.camera.getPicture(options).then(async (imageData) => {
      if(this.platform.is('ios')){
         await this.statusBar.overlaysWebView(true);
         await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        this.imgUrl = base64Image;
      }
      else
        this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " "+localStorage.imgsize+"MB", "invalid");
    }, async(err) => {
      if (this.platform.is('ios')) {
          await this.statusBar.overlaysWebView(true);
          await this.statusBar.overlaysWebView(false);
        }
    });
  }

  edit() {
    this.editflg = "update"
  }

  async updatedetails() {
    let request: any;
    let date: any;
    let profile: any;
    let name: any;
    let dobdate: any;

    this.profileName = this.profileName.replace(/[^a-zA-Z ]+/g, '');
    if (this.cmndecl.cordovaSupport)
      dobdate = this.profileDoB;
    else
      dobdate = moment(this.profileDoB).format("DD/MM/YYYY");
    if (this.profileDoB == "" || this.profileDoB == undefined)
      date = "";
    else
      date = dobdate;
    if (this.profileEmail == "" || this.profileEmail == undefined)
      name = "";
    else
      name = this.profileEmail;

    if (this.profileName != '' && this.profileName != undefined && (this.role == 'existing' || (this.role != 'existing' && ((this.profileForm.get("profileEmail").valid && this.profileEmail != "" && this.profileEmail != undefined) || (this.profileEmail == "" || this.profileEmail == undefined))))) {
      await this.cmndef.loaderstart();
      if (this.imgUrl == "assets/images/profile_icon.png")
        profile = "";
      else {
        profile = this.imgUrl.substring((this.imgUrl.indexOf(",") + 1), this.imgUrl.length)
      }
      request = {
        "mobileNo": this.profileMobile,
        "requestType": "updateUserDetails",
        "userSessionID": localStorage.userSessionID,
        "userDisplayName": this.profileName,
        "dob": date,
        "userDisplayImage": profile,
        "emailId": name
      }
      this.api.clickenventcap("updateProfileDetailsButton");
      await this.api.postapi("updateDetails", request).then(async data => {
        await this.cmndef.loaderend();
        this.getprofileData("update");
      }, err => {
        this.cmndef.loaderend();
      })
    }
  }

  validatefun(flg: any) {
    this.profileName = this.profileName.replace(/[^a-zA-Z ]+/g, '');
  }


  // For Browser
  changeListener($event): void {
    this.cmndef.readThis($event.target).then(data=>{
      this.imgUrl = data;
    })
  }
}
